import { Box } from '@material-ui/core'
import { useEffect } from 'react'

import DropzoneInput from '@/components/dropzone-input'
import Loading from '@/components/loading'
import {
  DefaultProjectFormData,
  useProject,
} from '@/pages/projects-form/contexts/project-context'
import { useValidatePerimeterFiles } from '@/pages/projects-form/hooks/use-validate-perimeters-files'

import { useStyles } from './styles'

export interface SelectFilesProps {
  currentRegionIndex: number
  currentRegion: DefaultProjectFormData['regions'][number]
}

export function SelectFiles({
  currentRegionIndex,
  currentRegion,
}: SelectFilesProps) {
  const classes = useStyles()

  const {
    form: { setValue },
  } = useProject()

  const { mutate: onDropFiles, isLoading } = useValidatePerimeterFiles()

  function handleDropFiles(files: File[]) {
    onDropFiles(files, {
      onSuccess: ({ geojson }) => {
        setValue(`regions.${currentRegionIndex}.geojson`, geojson)
      },
    })
  }

  useEffect(() => {
    setValue(`regions.${currentRegionIndex}.col_name`, null)

    if (!currentRegion.id || currentRegion.synced)
      setValue(`regions.${currentRegionIndex}.is_new_file`, true)
  }, [currentRegion.id, currentRegion.synced, currentRegionIndex])

  if (isLoading) {
    return <Loading />
  }

  return (
    <Box height='100%' width='100%' padding='2.4rem 0 3.2rem'>
      <DropzoneInput
        activeLabel='Solte os arquivos.'
        label={
          <div className={classes.dropzoneLabel}>
            <span>Clique para selecionar o arquivo</span> ou solte os arquivos
            aqui.
          </div>
        }
        multiple
        accept={{
          'application/octet-stream': [
            '.kml',
            '.kmz',
            '.shp',
            '.dbf',
            '.cpg',
            '.prj',
            '.shx',
          ],
        }}
        onDropAccepted={handleDropFiles}
      />
    </Box>
  )
}
